import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Résout un chemin média : URL absolue (photo Google) telle quelle, sinon photo stockée.
export const mediaUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${BACKEND_URL}/api/afromap/photo/${p}`);

export const TOKEN_KEY = "bizarre_token";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Une erreur est survenue.";
}

export function isPaywall(e) {
  return e?.response?.status === 402;
}

export default api;
